import { useQuery } from "@tanstack/react-query";

import type { Activity, ActivityType } from "@/core/types";

import { activityListKey } from "../keyFactory";
import { getActivityList } from "../queryFunctions/getActivityList";

export function useActivityList({ isEnabled, type }: { isEnabled: boolean; type: ActivityType }) {
  return useQuery<Activity[]>({
    enabled: isEnabled,
    queryFn: () => getActivityList({ type }),
    queryKey: activityListKey.byType(type),
    refetchOnWindowFocus: false,
  });
}
